module.exports = __webpack_public_path__ + "img/title-5.515c927d.png";